import React, { useEffect, useState } from "react";
import { FormLabel, Stack } from "@mui/material";
import { notification, Select } from "antd";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { publishEvent } from "../../../components/generic/EventPublisher";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { executeIntent } from "../../utils/IntentExecutor";

const SelectVisitReportForm = ({ organizationIdentifier, forms }) => {
  const user = useReadMemory(MemoryType.USER);
  const [selectedForm, setSelectedForm] = useState(null);
  const [serviceKeys, setServiceKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = async (value) => {
    setSelectedForm(value);
    if (!serviceKeys.length) return;

    setLoading(true);
    const configurationValue = { templateCode: value };

    try {
      await Promise.all(
        serviceKeys.map((serviceKey) => {
          const payload = {
            intent: "add_configuration",
            payload: {
              configurationKey: serviceKey,
              configurationValue: JSON.stringify(configurationValue),
            },
            context: {
              organizationIdentifier,
            },
          };

          return performPostRequest(
            getApiUrl()[IntentType.ADD_CONFIGURATION],
            JSON.stringify(payload),
          );
        }),
      );

      publishEvent(
        "niramaya.organization.defaultform.updated",
        user,
        configurationValue,
        { templateCode: value },
      );
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchInitialValue = async () => {
      const payload = {
        intent: "get_configuration",
        payload: {
          configurationKey: serviceKeys,
        },
        context: {
          organizationIdentifier,
        },
      };

      try {
        const response = await performPostRequest(
          getApiUrl()[IntentType.GET_CONFIGURATION],
          JSON.stringify(payload),
        );
        const result = await response.json();
        const { templateCode } = JSON.parse(
          result[0]?.configurationValue || "{}",
        );

        setSelectedForm(templateCode);
      } catch (error) {
        notification.error({
          message: "Error while getting form template",
          placement: "bottomRight",
        });
      }
    };

    if (serviceKeys.length) {
      fetchInitialValue();
    }
  }, [organizationIdentifier, serviceKeys]);

  useEffect(() => {
    const getMasterList = async () => {
      const payload = {
        configurationKey: ["niramaya.organization.volunteerduties"],
      };

      const result = await executeIntent(
        IntentType.GET_CONFIGURATION,
        payload,
        {},
      );
      const masterList =
        result[0].configurationValue &&
        JSON.parse(result[0].configurationValue || "[]");
      const configurationKeys = masterList.map(
        (service) => service?.serviceKey,
      );
      setServiceKeys(configurationKeys);
    };

    getMasterList();
  }, []);

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <FormLabel>Visit Report</FormLabel>
      <Select
        style={{ width: 280 }}
        showSearch
        className="default-form-select"
        loading={loading}
        value={selectedForm}
        placeholder="Select Form"
        optionFilterProp="children"
        onChange={handleChange}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={forms}
      />
    </Stack>
  );
};

export default SelectVisitReportForm;
